import { FC } from 'react';
import { ICaremapNote, ICaremapNoteResponse } from '../notes/model/NotesClient';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CommentsModelFactory } from './CommentsModelFactory';
import { useSubscription } from '@meraki-internal/state';
import { CommentAvatar } from './CommentAvatar';
import { CommentViewer } from './CommentViewer';
import { INoteInteractionSurface } from '../notes/reactions/INoteInteractionSurface';

export type ICommentListProps = {
    note: ICaremapNote;
    surface: INoteInteractionSurface;
};

export const CommentList: FC<ICommentListProps> = ({ note, surface }) => {

    const factory = useInstance(CommentsModelFactory);
    useSubscription(() => factory);

    const model = factory.forNote(note);
    const comments = [...model.getComments()].sort((c1, c2) => c2.createdAt.localeCompare(c1.createdAt));

    const startEditing = (comment: ICaremapNoteResponse) => {
        model.startEditing(comment);
    };

    const deleteComment = async (comment: ICaremapNoteResponse) => {
        await model.deleteComment({ comment, surface });
    };

    return (
        <>
            {comments.map(comment => (
                <div
                    key={comment.noteId}
                    data-type="comment"
                    data-id={`comment-${comment.noteId}`}
                    style={{display: 'flex', alignItems: 'flex-start', gap: 15, margin: '20px 0px 20px 10px'}}
                >
                    <div>
                        <CommentAvatar size={36} author={comment.createdByUser} />
                    </div>
                    <div style={{flexGrow: 100}}>
                        <CommentViewer
                            comment={comment}
                            editHandler={model.canEdit(comment) ? startEditing : undefined}
                            deleteHandler={model.canDelete(comment) ? deleteComment : undefined}
                        />
                    </div>
                </div>
            ))}
        </>
    );
};
